import { useState, useEffect } from 'react';
import firebase from 'firebase/compat/app';
import { LocationFormModal, DeleteLocationModal } from '../components/locations';
import { NotificationToast } from '../components/common';

const db = firebase.firestore();

/**
 * Locations view - manage healthcare facility locations (admin only)
 */
export function LocationsView({ language }) {
  const [locations, setLocations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [editingLocation, setEditingLocation] = useState(null);
  const [deletingLocation, setDeletingLocation] = useState(null);
  const [notification, setNotification] = useState(null);

  useEffect(() => {
    const unsubscribe = db.collection('locations')
      .orderBy('createdAt', 'desc')
      .onSnapshot((snapshot) => {
        const locationsData = [];
        snapshot.forEach((doc) => {
          locationsData.push({ id: doc.id, ...doc.data() });
        });
        setLocations(locationsData);
        setLoading(false);
      }, () => setLoading(false));

    return () => unsubscribe();
  }, []);

  if (loading) {
    return <div className="loading">Lädt...</div>;
  }

  return (
    <div className="locations-view">
      <div className="view-header">
        <h2>Standorte</h2>
        <button className="btn-primary" onClick={() => setShowCreateModal(true)}>
          <i className="fas fa-plus"></i> Neuer Standort
        </button>
      </div>

      {locations.length === 0 ? (
        <p className="no-data">Keine Standorte vorhanden</p>
      ) : (
        <div className="locations-grid">
          {locations.map(location => (
            <div key={location.id} className={`location-card ${!location.active ? 'inactive' : ''}`}>
              <div className="location-header">
                <h3>{location.name}</h3>
                <span className={`badge ${location.active ? 'badge-active' : 'badge-inactive'}`}>
                  {location.active ? 'Aktiv' : 'Inaktiv'}
                </span>
              </div>

              <p className="location-address">
                <i className="fas fa-map-marker-alt"></i>
                {location.address}
              </p>

              {location.active && (
                <div className="location-actions">
                  <button
                    className="btn-secondary"
                    onClick={() => setEditingLocation(location)}
                  >
                    <i className="fas fa-edit"></i> Bearbeiten
                  </button>
                  <button
                    className="btn-danger"
                    onClick={() => setDeletingLocation(location)}
                  >
                    <i className="fas fa-trash"></i> Löschen
                  </button>
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      {showCreateModal && (
        <LocationFormModal
          onClose={() => setShowCreateModal(false)}
          onSuccess={() => {
            setShowCreateModal(false);
            setNotification({ message: 'Standort erstellt', type: 'success' });
          }}
        />
      )}

      {editingLocation && (
        <LocationFormModal
          location={editingLocation}
          onClose={() => setEditingLocation(null)}
          onSuccess={() => {
            setEditingLocation(null);
            setNotification({ message: 'Standort aktualisiert', type: 'success' });
          }}
        />
      )}

      {deletingLocation && (
        <DeleteLocationModal
          location={deletingLocation}
          onClose={() => setDeletingLocation(null)}
          onSuccess={() => {
            setDeletingLocation(null);
            setNotification({ message: 'Standort gelöscht', type: 'success' });
          }}
        />
      )}

      {notification && (
        <NotificationToast
          message={notification.message}
          type={notification.type}
          onClose={() => setNotification(null)}
        />
      )}
    </div>
  );
}

// ============================================================================
// LOCATION FORM MODAL
// ============================================================================

